var _rect, _path, _circle, _circle2, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 280 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logoGradDark",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#818cf8",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#fb923c",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iconGradDark",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#6366f1",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#818cf8",
      stopOpacity: 1
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 8,
    width: 44,
    height: 44,
    rx: 10,
    fill: "url(#iconGradDark)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16h14c4.4 0 8 3.1 8 7 0 2-0.9 3.8-2.3 5 2 1.3 3.3 3.4 3.3 5.8 0 4.2-3.8 7.2-8.5 7.2H12V16z             M17 26h8c1.7 0 3-1.1 3-2.6 0-1.4-1.3-2.5-3-2.5H17V26z             M17 37h9.5c2 0 3.5-1.3 3.5-3s-1.5-3-3.5-3H17V37z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 12,
    r: 5,
    fill: "#f97316"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 12,
    r: 3,
    fill: "white"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 54,
    y: 38,
    fontFamily: "Poppins, Inter, Arial",
    fontWeight: 800,
    fontSize: 22,
    fill: "url(#logoGradDark)",
    letterSpacing: -0.5
  }, "mybazaarx")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 54,
    y: 53,
    fontFamily: "Inter, Arial",
    fontWeight: 400,
    fontSize: 10,
    fill: "#9ca3af",
    letterSpacing: 1.5
  }, "BUY \xB7 SELL \xB7 TRUST")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.cd0a58be8823418b23ac5ec2e9f5a06c.svg";
export { ForwardRef as ReactComponent };